import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';
import Breadcrumbs from '@/components/custom/breadcrumbs/breadcrumbs';

const appName = process.env.REACT_APP_NAME;
const hasCustomLogos = appName === 'canaleducacao' || appName === 'maiseducacao';

const dashboardContentVariants = cva('ml-0 w-full max-w-screen overflow-x-hidden overflow-y-auto bg-neutral-bright ', {
  variants: {
    variant: {
      default: 'flex flex-col justify-start flex-wrap',
      plain: '',
      column: 'flex flex-col items-stretch justify-start'
    },
    minHeight: {
      default: 'min-h-screen', // 100vh
      minusHeader: 'min-h-[calc(100vh-68px)] md:min-h-screen' // 100vh - 68px
    },
    viewMode: {
      default: 'md:ml-16 md:w-[calc(100%-64px)]',
      create: 'md:ml-[260px] md:w-[calc(100%-260px)]'
    },
    padding: {
      default: '!px-4 pb-4 pt-[110px] md:!px-11 md:pb-11 md:pt-[104px]',
      none: '!p-0'
    }
  },
  defaultVariants: {
    variant: 'default',
    minHeight: 'default',
    viewMode: 'default',
    padding: 'default'
  }
});

const DashboardContent = React.forwardRef(({ className, variant, viewMode, padding, breadcrumbs, breadcrumbsVerified, breadcrumbsActions, children, ...props }, ref) => {
  const minHeightVariant = hasCustomLogos ? 'minusHeader' : 'default';

  return (
    <main
      ref={ref}
      className={cn('c-dashboard-content', dashboardContentVariants({ variant, viewMode, minHeight: minHeightVariant, padding }), className)}
      {...props}
    >
      {breadcrumbs && (
        <Breadcrumbs
          data={breadcrumbs}
          innerContent={breadcrumbsVerified}
          actions={breadcrumbsActions}
        />
      )}

      {children}
    </main>
  );
});
DashboardContent.displayName = 'DashboardContent';

const Dashboard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-dashboard', 'relative flex min-h-screen w-full flex-wrap items-start justify-between', className)}
    {...props}
  />
));
Dashboard.displayName = 'Dashboard';

export { DashboardContent, Dashboard };
